import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Form } from "antd";
import FormItem from "components/fields/FormItem";
import EmployeeInfoForm from "./EmployeeInfoForm";
import EmegencyContactForm from "./EmegencyContactForm";
import SectionHeader from "components/section/SectionHeader";
import PopupButton from "components/button/PopupButton";
import {
	getEmployeeDetails,
} from "../../../../redux/employee/employeeState";
import { formatAddress, isSeparatedEmployee, contactDetailName } from "utils/index";
import InfoCard from "components/card/InfoCard";
import { LuBuilding, LuLayers, LuMail, LuMapPin, LuPhone } from "react-icons/lu";




const EmployeeDetails = ({
	getRecord,
	recordData,
	recordId,
}) => {
	const [employee, setEmployee] = useState(null);

	useEffect(() => {
		getRecord(recordId);
	}, [recordId, getRecord]);

	useEffect(() => {
		if (recordData) {
			setEmployee(recordData);
		}
	}, [recordData]);

  	return (
		<div className="grid grid-cols-7 gap-x-4">
			<div className="col-span-4">
				<div className="content-wrapper p-5 mb-4 rounded-xl border shadow-md">
					<SectionHeader title="Personal Info">
						<PopupButton id="edit_employee" title="Edit Employee" label="Edit">
							<EmployeeInfoForm recordId={recordId} mode="edit" />
						</PopupButton>
					</SectionHeader>
					<Form layout="vertical">
						<div className="grid grid-cols-2 gap-x-2 w-full"> 
							<FormItem label="Hire Date" value={recordData?.emp_hire_date} />	
							{isSeparatedEmployee(recordData) && 
								<FormItem label="Separation Date" value={recordData?.emp_separation_date} />
							}
						</div>
						<div className="w-full"> 
							<FormItem label="Address" value={formatAddress(recordData?.user_detail?.address)} />
						</div>
						<div className="grid grid-cols-2 w-full"> 
							<FormItem label="TIN #" value={recordData?.emp_tin} />
							<FormItem label="SSS #" value={recordData?.emp_sss_number} />
							<FormItem label="PhilHealth #" value={recordData?.emp_philhealth_number} />
							<FormItem label="Pagibig #" value={recordData?.emp_pagibig_number} />
							<FormItem label="Pagibig MP2 #" value={recordData?.emp_pagibig_number_2} />
							<FormItem label="Bank Account Number" value={recordData?.emp_bank_account} />
						</div>
					</Form>
				</div>

				<div className="content-wrapper p-5 rounded-xl border shadow-md">
					<SectionHeader title="Emergency Contact Info">
						<PopupButton id="edit_emergency_contact" title="Edit Emergency Contact" label="Edit">
							<EmegencyContactForm recordId={recordId} mode="edit" />
						</PopupButton>
					</SectionHeader>

					<Form layout="vertical">
						<div className="grid grid-cols-2 gap-x-2 w-full">
							<FormItem 
								label="Name" 
								value={contactDetailName(recordData?.user_detail?.emergency_contact_person)} 
							/>
							<FormItem 
								label="Mobile Number" 
								value={recordData?.user_detail?.emergency_contact_person?.cde_mobile_number} 
							/>
							<FormItem 
								label="Email" 
								value={recordData?.user_detail?.emergency_contact_person?.cde_email} 
							/>
							<FormItem 
								label="Relation" 
								value={recordData?.user_detail?.emergency_contact_person?.cde_relation} 
							/>
						</div>
					</Form>
				</div>
			</div>
			<div className="col-span-3">
				<div className="content-wrapper p-5 rounded-xl border shadow-md h-full">
					<SectionHeader title="Employee Details">
						<PopupButton id="edit_employee" title="Edit Employee" label="Edit">
							<EmployeeInfoForm recordId={recordId} mode="edit" />
						</PopupButton>
					</SectionHeader>

					<Form layout="vertical">
						<div className="grid grid-cols-2 w-full gap-3">
							
							<InfoCard 
								label="Email"
								icon={<LuMail />}
								value={recordData?.emp_email}
								span="col-span-1"
							/>
							<InfoCard 
								label="Phone"
								icon={<LuPhone />}
								value={recordData?.user_detail?.contact_details?.cde_mobile_number}
								span="col-span-1"
							/>
							<InfoCard 
								label="Country"
								icon={<LuMapPin />}
								value={recordData?.user_detail?.country_name}
								span="col-span-1"
							/>
							<InfoCard 
								label="Job Level"
								icon={<LuLayers />}
								value={recordData?.job_level_name}
								span="col-span-1"
							/><InfoCard 
								label="Department"
								icon={<LuBuilding />}
								value={recordData?.department_name}
								span="col-span-2"
							/>
						</div>
					</Form>
				</div>
			</div>
		</div>
  	);
};

const mapStateToProps = (state) => ({
  recordData: state.employee.employeeDetails?.data,
  requesting: state.employee.employeeDetails?.requesting,
  success: state.employee.employeeDetails?.success,
});

const mapDispatchToProps = (dispatch) => ({
  getRecord: (id) => dispatch(getEmployeeDetails(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeDetails);
